import { useState, useEffect } from "react";

import { Button } from "./component.js";

// GcodeSelectModal prompts staff to pick a Post-Alignment g-code project template.
// Used for in-place g-code / tier changes on an existing Post-Alignment project.
// New → Established conversion is automatic at program month 7.
function GcodeSelectModal({
  patient,
  templates,
  submitting,
  onClose,
  onConfirm,
  title,
  subtitle,
  confirmText,
  initialTemplateID,
}) {
  const [templateID, setTemplateID] = useState(initialTemplateID || null);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  const headerTitle = title || "Convert to Post-Alignment (Established)";
  const headerSubtitle = subtitle || (
    `${patient.firstName} ${patient.lastName} is due for Post-Alignment (Established). Select the g-code to continue.`
  );
  const idleConfirmText = confirmText || "Convert";
  const busyConfirmText = confirmText ? "Saving..." : "Converting...";
  const canConfirm = !!templateID && (!initialTemplateID || templateID !== initialTemplateID);

  return (
    <div
      className="fixed inset-0 z-2000 flex items-center justify-center bg-[#80808094]"
      onClick={submitting ? undefined : onClose}
    >
      <div className="w-full max-w-md px-8">
        <div className="card shadowmore" onClick={(e) => e.stopPropagation()}>
          <div className="card-header">
            <span className="typo-header-3xLarge">{headerTitle}</span><br/>
            <span className="typo-normal-175 text-muted">{headerSubtitle}</span>
          </div>
          <div className="card-content">
            {(templates || []).map((template) => (
              <div
                key={template.id}
                className={"side-item " + (templateID === template.id ? "active" : "")}
                onClick={submitting ? undefined : () => setTemplateID(template.id)}
              >
                <div>
                  <div className="typo-strong-175">{template.title}</div>
                  <div className="typo-normal-150">{template.description}</div>
                </div>
              </div>
            ))}

            <div className="d-flex justify-content-end align-items-center mt-4">
              <Button
                text="Cancel"
                color="grey"
                muted
                disabled={submitting}
                onClick={onClose}
                className="me-2"
              />
              <Button
                text={submitting ? busyConfirmText : idleConfirmText}
                color="blue"
                disabled={submitting || !canConfirm}
                onClick={() => onConfirm(templateID)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GcodeSelectModal;
